<template>
  <div class="home-index">
    <component
      v-if="currentComponent"
      :is="currentComponent"
      v-bind="currentComponentProps"
    />

  </div>
</template>

<script setup>
import { inject, computed, watch, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'
import HomeGuestContent from '@/components/sites/modules/HomeGuestContent.vue'
import HomeUserDashboard from '@/components/sites/modules/HomeUserDashboard.vue'
import VertragIndex from '@/components/sites/VertragIndex.vue'
import { CLEARMENT_TITLE, CLEARMENT_DESCRIPTION } from '@/constants/documentHead'

const userStore = inject('userStore')
const baseCalls = inject('baseCalls')
const router = useRouter()
const updateDocumentHead = inject('updateDocumentHead')
updateDocumentHead?.(CLEARMENT_TITLE, CLEARMENT_DESCRIPTION)

const { userData } = storeToRefs(userStore)
const contracts = ref([])
const contractsLoaded = ref(false)

const isAdmin = computed(() => {
  const user = userData.value
  if (!user || !user.user_admin) return false
  return Number(user.user_admin) === 1
})

const singleContractId = computed(() => {
  if (contracts.value.length === 1) {
    return contracts.value[0].myp_id || null
  }
  return null
})

const currentComponent = computed(() => {
  if (!userData.value) return HomeGuestContent
  if (isAdmin.value) return null
  if (!contractsLoaded.value) return null
  if (contracts.value.length === 1) return VertragIndex
  return HomeUserDashboard
})

const currentComponentProps = computed(() => {
  if (currentComponent.value === VertragIndex && singleContractId.value) {
    return { initialMypId: singleContractId.value }
  }
  return {}
})

async function loadUserContracts() {
  if (!userData.value || isAdmin.value) {
    contracts.value = []
    contractsLoaded.value = true
    return
  }
  try {
    const response = await baseCalls.clearmentPost({
      action: 'getmyproducts'
    })
    if (response.data.success && Array.isArray(response.data.products)) {
      contracts.value = response.data.products
    } else {
      contracts.value = []
    }
    contractsLoaded.value = true
  } catch (error) {
    console.error('Error loading contracts for home page:', error)
    contracts.value = []
    contractsLoaded.value = true
  }
}

watch(
  isAdmin,
  (value) => {
    if (value) {
      router.replace({ name: 'adminindex' })
    }
  },
  { immediate: true }
)

watch(
  () => userData.value,
  (value) => {
    if (!value) {
      contracts.value = []
      contractsLoaded.value = false
    } else {
      contractsLoaded.value = false
      loadUserContracts()
    }
  },
  { immediate: true }
)
</script>

<style scoped src="@/assets/styles/sfc/components/sites/HomeIndex.css"></style>
